import { Tag, Tooltip } from "@jutro/ui";
import { unique } from "radash";
import { EdmMedicalAppShiftWithoutVisitFragment } from "lib/graphql/megaSchema";
import { visitTypeLabelMap } from "views/StaffSchedule/tools";

type Props = {
  visitTypes: EdmMedicalAppShiftWithoutVisitFragment["visitTypes"];
};

export const VisitTypesCell = ({ visitTypes }: Props) => {
  const mappedVisitTypes = unique(
    visitTypes.map((visitType) => visitTypeLabelMap[visitType]),
  );

  const hasMoreThanTwoVisitTypes = visitTypes.length > 2;

  return (
    <div className="flex h-6 min-w-80 items-center gap-2.5">
      {mappedVisitTypes.slice(0, 2).map((visitType, index) => (
        <Tag text={visitType} key={`${index}${visitType}`} />
      ))}
      {hasMoreThanTwoVisitTypes && (
        <Tooltip
          position="top"
          trigger={
            <button>
              <Tag text={`+${visitTypes.length - 2}`} />
            </button>
          }
          content={mappedVisitTypes.slice(2).join(", ")}
        />
      )}
    </div>
  );
};
